import { render, staticRenderFns } from "./PromotionParticipantPicker.vue?vue&type=template&id=6085a02b&scoped=true&"
import script from "./PromotionParticipantPicker.vue?vue&type=script&lang=js&"
export * from "./PromotionParticipantPicker.vue?vue&type=script&lang=js&"
import style0 from "./PromotionParticipantPicker.vue?vue&type=style&index=0&id=6085a02b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085a02b",
  null
  
)

export default component.exports